import { usePermissions } from "../../contexts/PermissionsProvider";

export function Permissions({ requiredPermissions = [], children, ...props }) {
    const { permissions = [] } = usePermissions();
  
    // Verifica se o usuário possui as permissões necessárias
    const hasRequiredPermissions = requiredPermissions.every((reqPerm) =>
      permissions.some(
        (userPerm) =>
          userPerm.entidade === reqPerm.entidade &&
          reqPerm.actions.every((action) => userPerm[action] === 1)
      )
    );
  
    // Se o usuário tiver as permissões necessárias, renderiza o botão
    if (hasRequiredPermissions) {
      return <>{children}</>;
    }
  
    // Caso contrário, não renderiza nada
    return null;
  }
  